import React, { ReactNode } from "react"

import BackgroundWrapper from "@fuse/sharedComponents/backgroundWrapper"
import BlurWrapper from "@fuse/sharedComponents/blurWrapper"

interface BuyTicketsLayoutProps {
  header: ReactNode
  content: ReactNode
  footer: ReactNode
  bgImage?: string
  overlayOpacity?: string
  overlayColor?: string
}

const BuyTicketsLayout: React.FC<BuyTicketsLayoutProps> = ({
  header,
  content,
  footer,
  bgImage,
  overlayOpacity = "75",
  overlayColor = "dark",
}) => {
  return (
    <div className="min-h-screen flex flex-col">
      <BackgroundWrapper bgImage={bgImage} className="min-h-screen">
        <BlurWrapper
          overlayOpacityDefault={overlayOpacity}
          overlayColorDefault={overlayColor}
          className="min-h-screen"
        >
          {/* Layout with sticky header and footer */}
          <div className="h-screen flex flex-col overflow-hidden">
            <div className="flex-1 overflow-y-auto">
              {/* Sticky header */}
              <header className="sticky top-0 z-20">{header}</header>

              {/* Main content area - takes available space and scrolls naturally */}
              <main className="flex-1">{content}</main>

              {/* Sticky footer */}
              <footer className="fixed bottom-0 z-20 my-4 w-full">
                {/* <footer className="sticky bottom-0 z-20 my-4 w-full"> */}
                {footer}
              </footer>
            </div>
          </div>
        </BlurWrapper>
      </BackgroundWrapper>
    </div>
  )
}

export default BuyTicketsLayout
